import React from 'react';
import moment from 'moment';

class CustomModalBody extends React.Component {

    render() {
        return (
            <form className="units">
                <div className="units__block units__block-edit">
                    <div
                        className="text-field"
                    >
                        <label className="text-field__label" htmlFor="">Date</label>
                        <input
                            className="text-field__input"
                            type="text"
                            disabled={true}
                            value={moment(this.props.data.startDate).format('DD/MM/YYYY')}
                        />
                        <span className="kr kr-calendar" />
                    </div>
                </div>
                <div className="units__block">
                    <p className="units__subtitle">Number of units</p>
                    <div className="units__number">
                        <div
                            className={(!this.props.validationNumberZyrconia.status) ? "text-field" : "text-field has-error"}
                        >
                            <label className="text-field__label" htmlFor="">Zirconia
                                <small> (Already booked {this.props.data.alreadyBookedZirconia}) </small></label>
                            <input
                                className="text-field__input"
                                type="number"
                                value={this.props.data.units_for_zirconia}
                                placeholder="Number of units"
                                onChange={(e) => this.props.handelChangeEdit('units_for_zirconia', e.target.value)}
                            />
                            <span className="error-message">{this.props.validationNumberZyrconia.message}</span>
                        </div>
                        <div
                            className={(!this.props.validationNumber.status) ? "text-field" : "text-field has-error"}
                        >
                            <label className="text-field__label" htmlFor="">Misc
                                <small> (Already booked {this.props.data.editNumberOfUnits})</small></label>
                            <input
                                className="text-field__input"
                                type="number"
                                value={this.props.data.inputNumberOfUnits}
                                placeholder="Number of units"
                                onChange={(e) => this.props.handelChangeEdit('inputNumberOfUnits', e.target.value)}
                            />
                            <span className="error-message">{this.props.validationNumber.message}</span>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default CustomModalBody;



// WEBPACK FOOTER //
// ./src/components/AvailableUnits/editUnits.js